import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InterceptorHttpParams } from '../../../core/error/http-error-interceptor.service';

const resourceBaseUrl = '/api/v1/sales-leads';

export type SalesLeadEventId =
  | 'LEAD-SWS-AMER-MRKPLC-SMPL-DWNLD'
  | 'LEAD-SWS-AMER-MRKPLC-PRINT-PDF'
  | 'LEAD-SWS-AMER-MRKPLC-SHARE-MAP'
  | 'LEAD-SWS-AMER-MRKPLC-CONTACT-ME';

export interface ISalesLead {
  contactMeNow: boolean;
  eventIds: SalesLeadEventId[];
  oktaId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  comment?: string;
  areaOfInterest?: string;
  contactMeNowReason?: string;
  industry?: string;
  title?: string;
  phone?: string;
  address?: {
    country: string;
    stateOrProvince: string;
  };
  companyName?: string;
}

// TODO - This is likely in duplicate with the ContactUs story currently being worked on. Remove if not to be used.
export interface IProductSalesLead extends ISalesLead {
  email: string;
  firstName: string;
  lastName: string;
  oktaId: string;
  webFormDownloads: ILeadProduct[];
}

export interface ILeadProduct {
  id: string;
  name: string;
}

export interface ICreateSalesLeadResult {
  leadId: string;
}

@Injectable({
  providedIn: 'root',
})
export class SalesLeadDataAccessService {
  constructor(private _httpClient: HttpClient) {}

  public createSalesLead(salesLead: ISalesLead): Observable<ICreateSalesLeadResult> {
    // Example: disable global error handling for all http errors.
    // Don't handle any errors globally. We don't want the download interrupted.  We will log the error instead.
    const params = new InterceptorHttpParams({
      statusCodesToIgnore: (_error) => true,
    });
    return this._httpClient.post<ICreateSalesLeadResult>(resourceBaseUrl, salesLead, { params });
  }
}
